module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-toyota.95611718.png";